export { default } from './AppPromo';
